import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=50e11f12&scoped=true"
import script from "./Competition.vue?vue&type=script&lang=js"
export * from "./Competition.vue?vue&type=script&lang=js"
import style0 from "./Competition.vue?vue&type=style&index=0&id=50e11f12&prod&lang=less&scoped=true"
import style1 from "./Competition.vue?vue&type=style&index=1&id=50e11f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e11f12",
  null
  
)

export default component.exports